import { Button, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

import type {
  Action,
  ActionActionItemUnion,
  ExternalNavigation,
  InternalNavigation,
  MainSlider as MainSliderType,
  Pages,
} from "~/core";

type MainSliderButtonsProps = {
  controls: NonNullable<
    NonNullable<
      ExtractArrayItemType<MainSliderType["slides"]>
    >["main_slider_slides_id"]
  >["controls"];
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  isControlInactive: (control: Action) => boolean;
};

const isExternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is ExternalNavigation => {
  return "href" in (action ?? {});
};
const isInternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is InternalNavigation => {
  return "page" in (action ?? {});
};

export const MainSliderButtons: FC<MainSliderButtonsProps> = ({
  controls,
  getUrl,
  onCallAction,
  isControlInactive,
}) => {
  return (
    <Flex
      align="center"
      justify="center"
      gap={16}
      md={{
        justify: "flex-start",
        m: { mt: 0 },
      }}
      d={{ gap: 16 }}
      m={{ mb: 16, mt: "auto" }}
    >
      {controls
        ?.filter((control) => {
          if (control?.main_slider_slide_controls_id?.action) {
            return !isControlInactive(
              control.main_slider_slide_controls_id.action,
            );
          }

          return true;
        })
        .map((control, idx) => {
          const controlAction = control?.main_slider_slide_controls_id?.action;
          const action = controlAction?.action?.[0];
          let href;
          if (isExternalLink(action?.item)) {
            href = action.item.href ?? undefined;
          }
          if (isInternalLink(action?.item)) {
            href = action.item.page ? getUrl(action.item.page) : undefined;
          }

          return (
            <Button
              horizontalAlign="center"
              href={href}
              key={control?.id}
              variant={
                control?.main_slider_slide_controls_id?.variant === "primary"
                  ? "default"
                  : "transparent"
              }
              size="small"
              fontWeight="desktop.bold"
              md={{
                p: 18,
                minWidth: 215,
                fontSize: "button.desktop.medium",
                lineHeight: "button.desktop.medium",
              }}
              onPress={() => {
                if (controlAction) {
                  onCallAction(controlAction);
                }
              }}
              p={12}
              minWidth={148}
              data-testid={`main-slider-button-${idx}`}
            >
              {control?.main_slider_slide_controls_id?.text}
            </Button>
          );
        })}
    </Flex>
  );
};
